import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

interface Props {
  id: number;
  archivedAt: string | null;
}

export const ArchivedWarning = ({ id, archivedAt }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-2 rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-[9px] text-sm text-amber-700">
      <AlertTriangle className="h-5 w-5" />
      <span>
        {archivedAt === null
          ? t("commons.document.archivedVersionWarning")
          : t("commons.document.archivedProject")}
      </span>
      {archivedAt === null && (
        <Link to={`/documents/${id}`} className="underline">
          {t("commons.document.goToLatestVersion")}
        </Link>
      )}
    </div>
  );
};
